import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { GlobalAds } from "@/components/AdSlots";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import ToolPage from "@/pages/ToolPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import StaticPage from "@/pages/StaticPage";
import AdminApp from "@/admin/AdminApp";

const Site = () => (
  <div className="App min-h-screen bg-background">
    <GlobalAds />
    <Header />
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category/:id" element={<Category />} />
        <Route path="/tool/:slug" element={<ToolPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/page/:slug" element={<StaticPage />} />
      </Routes>
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <BrowserRouter>
        <Routes>
          <Route path="/control/*" element={<AdminApp />} />
          <Route path="/*" element={<Site />} />
        </Routes>
        <Toaster position="top-center" />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
